import type { AxiosInstance, AxiosResponse } from 'axios';
import axios from 'axios';

import type { HttpClient, HttpResponse } from '@/types/http';

type HttpClientOptions = {
  baseURL?: string;
  headers?: Record<string, string>;
  withCredentials?: boolean;
};

function normalizeResponse<T>(response: AxiosResponse<T>): HttpResponse<T> {
  return {
    data: response.data,
    status: response.status,
    headers: Object.fromEntries(Object.entries(response.headers)),
  };
}

export function createHttpClient(options?: HttpClientOptions): HttpClient {
  let ax: AxiosInstance | null = null;
  const getAx = () => {
    ax ??= axios.create(options);
    return ax;
  };
  return {
    get: (url, config) => getAx().get(url, config).then(normalizeResponse),
    delete: (url, config) => getAx().delete(url, config).then(normalizeResponse),
    head: (url, config) => getAx().head(url, config).then(normalizeResponse),
    options: (url, config) => getAx().options(url, config).then(normalizeResponse),
    post: (url, data, config) => getAx().post(url, data, config).then(normalizeResponse),
    put: (url, data, config) => getAx().put(url, data, config).then(normalizeResponse),
    patch: (url, data, config) => getAx().patch(url, data, config).then(normalizeResponse),
  };
}
